import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/refund-policy")({
  component: () => <Navigate to="/refund" replace />,
});
